import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';

import { removeLeadingString } from 'utils/path';
import type { WithTestId } from 'types/app';

import { OfferFeatureKindEnum } from '@Modules/offers/types';
import { selectLanguage } from '@Modules/app/selectors';
import type { FeatureValueType } from '@Modules/offers/types';

import { LinkRouter } from '@Atomic/atoms/LinkRouter';
import { Text } from '@Atomic/atoms/Text';

import styles from './feature.module.scss';

type Props = {
  className?: string;
  title: string;
  type: OfferFeatureKindEnum;
  values: FeatureValueType[];
};

export const OfferFeature = ({ className, title, type, values, testId }: WithTestId<Props>) => {
  const language = useSelector(selectLanguage);
  const separator = type === OfferFeatureKindEnum.Category ? ' · ' : ', ';

  return (
    // BP-7916: title and value flow as a single wrapped line (no fixed-width columns),
    // so both live inside one <Text> paragraph.
    <Text className={cn(className, styles.feature)} testId={testId}>
      <span className={styles.featureTitle}>{title}: </span>
      {values.map((value, index) => {
        const uri = value.webUriInfo?.[language];

        return (
          <Fragment key={index}>
            {index > 0 ? separator : null}
            {uri ? (
              <LinkRouter to={`/${removeLeadingString(uri, '/')}`} className={styles.featureLink}>
                {value.formattedValue}
              </LinkRouter>
            ) : (
              value.formattedValue
            )}
          </Fragment>
        );
      })}
    </Text>
  );
};
